import React from "react";

const ModalBackground = ({ clicked }) => {
  return <div className="__me" onClick={clicked}></div>;
};

export default ModalBackground;
